module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_10.d495564a.mp3";